var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return Object.keys(_vm.basicInfo).length
    ? _c("div", { staticStyle: { padding: "15px 0" } }, [
        _c(
          "div",
          {
            staticStyle: {
              display: "flex",
              "justify-content": "space-between",
              "align-items": "center",
            },
          },
          [
            _c(
              "div",
              [
                _c("span", { staticClass: "title" }, [_vm._v("个人基本信息")]),
                _c("a-range-picker", {
                  staticStyle: { width: "240px", "margin-left": "10px" },
                  model: {
                    value: _vm.dateRang,
                    callback: function ($$v) {
                      _vm.dateRang = $$v
                    },
                    expression: "dateRang",
                  },
                }),
                _c(
                  "a-button",
                  {
                    staticStyle: { "margin-left": "10px" },
                    attrs: { type: "primary" },
                    on: { click: _vm.handleSearch },
                  },
                  [_vm._v("查询")]
                ),
              ],
              1
            ),
            _c("div", [_vm._v("学生档案数据统计")]),
          ]
        ),
        _c("div", { staticClass: "personal-card" }, [
          _c("div", { staticClass: "avatar" }, [
            _c("img", {
              staticStyle: { width: "100%", height: "100%" },
              attrs: {
                src: _vm.$getStoreHttpUrl(_vm.basicInfo.pic),
                alt: "头像",
              },
            }),
          ]),
          _c("div", { staticClass: "personal-info" }, [
            _c("div", [_vm._v("姓名：" + _vm._s(_vm.basicInfo.studentName))]),
            _c("div", [_vm._v("学校：" + _vm._s(_vm.basicInfo.schoolName))]),
            _c("div", [_vm._v("班级：" + _vm._s(_vm.basicInfo.className))]),
            _c("div", [
              _vm._v("提醒次数：" + _vm._s(_vm.basicInfo.warnCnt) + "次"),
            ]),
          ]),
          _c("div", { staticClass: "personal-info" }, [
            _c("div", [_vm._v("家长电话：" + _vm._s(_vm.basicInfo.phone))]),
            _c("div", [
              _vm._v(
                "关爱名单：" +
                  _vm._s(_vm.getDictCodeData(_vm.basicInfo.careList))
              ),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "color-box-area" },
            _vm._l(_vm.statusList, function (item, index) {
              return _c("div", { key: index, staticClass: "color-box" }, [
                _c("div", { staticStyle: { height: "35px" } }, [
                  _vm.basicInfo.careList == index
                    ? _c("img", {
                        staticStyle: { width: "auto", height: "100%" },
                        attrs: {
                          src: require("@/assets/careListPos.png"),
                          alt: "正常",
                        },
                      })
                    : _vm._e(),
                ]),
                _c("div", {
                  style: {
                    backgroundColor: item.color,
                    width: "60px",
                    height: "24px",
                  },
                }),
                _c("div", { staticStyle: { margin: "20px 0" } }, [
                  _c("span", {
                    staticClass: "iconfont",
                    style: { backgroundColor: item.color },
                  }),
                  _vm._v("\n          " + _vm._s(item.label) + "\n        "),
                ]),
              ])
            }),
            0
          ),
        ]),
      ])
    : _c("EmptyData", {
        attrs: { styleObj: { padding: "30px 0" }, loading: _vm.loading },
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }